import React from 'react';
import { Card } from '@clockout-dev/design-elements';
import AdvanceSummaryCardHeader from './elements/AdvanceSummaryCardHeader';
import FeeByVolumeChart from './elements/FeeByVolumeChart';
import DeliveryTiersStrip from './elements/DeliveryTiersStrip';
import AdvanceSummaryKpiGroup from './elements/AdvanceSummaryKpiGroup';
import { BASE_ADVANCE_AMOUNT, MOCK_AVATAR_URL, MOCK_USER_NAME } from './advanceSummaryCard.constants';
import styles from './styles/advanceSummaryCard.module.scss';
import { formatCurrency } from '../../../../utils/numbers';


function AdvanceSummaryCard({ state }) {
    const { fee = 0, fee_policy = {}, feeByVolume } = state || {};
    const feeInstance = fee_policy.feeInstance || 'on-advance';
    const standardDelivery =
        fee_policy.standardFreeAdvanceTime && fee_policy.standardFreeAdvanceUnit
            ? `${fee_policy.standardFreeAdvanceTime} ${fee_policy.standardFreeAdvanceUnit.replace('-', ' ')}`
            : undefined;

    const advanceFee = Number(fee) || 0;
    const advance = BASE_ADVANCE_AMOUNT;
    const userReceives = feeInstance === 'on-advance' ? advance - advanceFee : advance;
    const userRepays = feeInstance === 'on-repayment' ? advance + advanceFee : advance;

    const advanceRows = [
        { label: 'Requested Advance Amount', value: formatCurrency(advance) },
        { label: 'Advance Fee', value: formatCurrency(advanceFee), tone: 'fee' },
        { label: `${MOCK_USER_NAME} Receives`, value: formatCurrency(userReceives), tone: 'highlight' },
    ];

    const repaymentRows = [
        { label: 'Total Advance Amount', value: formatCurrency(advance) },
        { label: 'Total Fee Amount', value: formatCurrency(advanceFee), tone: 'fee' },
        { label: `${MOCK_USER_NAME} Repays`, value: formatCurrency(userRepays), tone: 'highlight' },
    ];

    return (
        <Card className={styles.summaryCard}>
            <AdvanceSummaryCardHeader userName={MOCK_USER_NAME} avatarUrl={MOCK_AVATAR_URL} />
            <DeliveryTiersStrip instantFee={advanceFee} standardLabel={standardDelivery} />
            <FeeByVolumeChart {...(feeByVolume || {})} />
            <AdvanceSummaryKpiGroup label="Advance" rows={advanceRows} />
            <AdvanceSummaryKpiGroup label="Repayment" rows={repaymentRows} />
        </Card>
    );
}

export default AdvanceSummaryCard;
